export default "__VITE_ASSET__C3LicY2X__"